(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/size-picker.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/size-picker.js'); 
'use strict';

svs.numbergames.game.views.SizePicker = Marionette.View.extend({
  possibleSizes: {},
  invertButtons: false,
  ui: {
    sizeRadio: '.js-size-radio'
  },
  triggers: {
    'change @ui.sizeRadio': 'changeSize'
  },
  className() {
    const brandingSuffix = svs.numbergames.productMapping.getBrandingClass(this.model.get('productId'));
    return "numbergames-size-picker numbergames-size-picker-".concat(brandingSuffix);
  },
  template(data) {
    return svs.numbergames.game.templates.size_picker(data);
  },
  templateContext() {
    const rules = svs.numbergames.game_model.rulesRadio.request('rules');
    const packageRules = rules.PACKAGES;
    if (!packageRules) return;
    return {
      possibleSizes: Object.keys(packageRules),
      size: this.options.size,
      invertButtons: this.getOption('invertButtons')
    };
  },
  onChangeSize(view, event) {
    const size = event.target.value;
    Backbone.history.navigate("fardiga-spel/".concat(size), {
      replace: true
    });
    this.model.setPackage(size);
  }
});
 })(window);